"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormGroupContext", {
    enumerable: true,
    get: function() {
        return FormGroupContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormGroupContext = /*#__PURE__*/ _react.default.createContext({
    hasError: false
});

//# sourceMappingURL=FormGroupContext.js.map